import { api, buildQueryString } from '../core';
import { BUNDLE_GET_DOWNLOAD_TAG } from '../constants';
import { type BundleTypeKeys, RootState, setBundleDownloadAzureData } from '@/store';

export interface BundleGetDownloadAzureData {
  downloadPath: string;
  downloadToken: string;
}

interface BundleGetDownloadResponse {
  bundleDownload: BundleGetDownloadAzureData;
  indexDownload: BundleGetDownloadAzureData;
}

type BundleGetDownloadProps = {
  bundleId: string;
  bundleKey?: BundleTypeKeys;
};

export const getBundleGetDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundleGetDownload: builder.query<BundleGetDownloadResponse, BundleGetDownloadProps>({
      query: (params: BundleGetDownloadProps) => {
        const queryString = buildQueryString(params, { bundleId: 'bundleId' });

        return {
          url: `bundle/get-download?${queryString}`,
          method: 'GET',
        };
      },
      providesTags: (_result, _err, { bundleId }) => [{ type: BUNDLE_GET_DOWNLOAD_TAG, id: bundleId }],
      async onQueryStarted({ bundleKey }, { dispatch, queryFulfilled, getState }) {
        try {
          const { data } = await queryFulfilled;
          const state = getState() as RootState;
          const resolvedBundleKey = bundleKey ?? state.sharedData.activeBundleType;

          if (resolvedBundleKey) {
            dispatch(
              setBundleDownloadAzureData({
                key: resolvedBundleKey,
                data: data?.bundleDownload ? data.bundleDownload : null,
              }),
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getBundleGetDownload in onQueryStarted:', error);
          }
        }
      },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetBundleGetDownloadQuery } = getBundleGetDownloadApi;
